import { usePortalContext } from '@consta/uikit/PortalWithTheme'
import { useClickOutside } from '@consta/uikit/useClickOutside'
import type { FC, ReactElement, ReactNode, RefObject } from 'react'

/**
 * Подписчик на PortalWithThemeProvider
 * получает рефы всех вложенных порталов в модалку
 * для дальнейшего исключения их из useClickOutside
 */
export const ContextConsumer: FC<{
  onClickOutside?: (event: MouseEvent) => void
  ignoreClicksInsideRefs?: ReadonlyArray<RefObject<HTMLElement>>
  children: ReactNode
}> = ({ onClickOutside, children, ignoreClicksInsideRefs }) => {
  const { refs } = usePortalContext()

  useClickOutside({
    isActive: !!onClickOutside,
    ignoreClicksInsideRefs: [...(ignoreClicksInsideRefs ?? []), ...refs],
    handler: onClickOutside,
  })

  return children as ReactElement
}
